<script>
import { layoutMethods, languageMethods } from "@/state/helpers";
import i18n from "../i18n";
import { decodeJwtTokenPayload } from "../helpers/jwtHelper";
import { toast } from "vue3-toastify";
import { guestLogout } from "../helpers/guestHelper";
import { languages, setLanguage as setLang, initLanguageFlag } from "@/helpers/languageHelper";

import { routeAndMenuComputed, routeMethods } from "../state/helpers";


export default {
  data() {
    return {
      userFullName: "",
      userFirstName: "",
      activeRole: "",
      dosya: `${require("@/assets/images/avatar/14-small.png")}`,
      isImpersonate: false,
      impId: 0,
      isProxyRole: false,
      roleInfos: [],
      proxyRoleInfos: [],
      ProxySicilNo: "",
      searchResult: [],
      routes: [],
      roleName: "",
      menuItems: [],
 

      languages,
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      myVar: 1,
      developmentWarnShow: false,
    };
  },
  components: {
  },
  methods: {
    ...layoutMethods,
    ...languageMethods,
    ...routeMethods,
    onRoutechange() {

    },

    redirectToProfil() {
      window.location.href = "https://atilim.edu.tr";
    },
    async logout(event) {
         event.preventDefault();
          await guestLogout(this.$router);
    },
  

    showWelcomeMsg(loggedUserToken) {
      let resultUserInfo = decodeJwtTokenPayload(loggedUserToken);
      let welcomeMessageUser = resultUserInfo.Email;

      toast.success(`Hoş Geldiniz Sn. ${welcomeMessageUser}`, {
        type: "default",
        theme: "colored",
        position: "bottom-right",
        transition: "zoom",
        autoClose: 3000,
      });
    },

    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      setLang(locale, country, flag);
    },
  
    toggleDarkMode() {
      if (document.documentElement.getAttribute("data-bs-theme") == "dark") {
        document.documentElement.setAttribute("data-bs-theme", "light");
      } else {
        document.documentElement.setAttribute("data-bs-theme", "dark");
      }

      const mode = document.documentElement.getAttribute("data-bs-theme");
      this.changeMode({
        mode: mode,
      });
    },
   
  },
  watch: {
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },

  },
  computed: {
    ...routeAndMenuComputed,
  },
  mounted() {
    let dil = localStorage.getItem("language") || "tr";
    this.flag = dil;
    initLanguageFlag();

  },
  async created() {
    if (process.env.VUE_APP_FRONTEND_URL !== "https://unacs.atilim.edu.tr")
      this.developmentWarnShow = true;
    this.menuItems = [];
    let token = localStorage.getItem("token");
    if (token) {
       let resultUserInfo = decodeJwtTokenPayload(token);
       this.userFullName = resultUserInfo.Email;
       this.userFirstName = resultUserInfo.Email;
    }
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="layout-width">
      <div class="navbar-header">
        <div class="d-flex">
          <!-- LOGO -->
        
     
              <span class="logo-sm">
                <img src="@/assets/images/logo-sm.png" alt="" height="22" />
              </span>
              <span class="logo-lg">
                <img src="@/assets/images/logo-dark.png" alt="" height="17" />
              </span>
           
        
   
        </div>

        <div class="d-flex align-items-center">
        
          <BDropdown
            class="dropdown"
            variant="ghost-secondary"
            dropstart
            :offset="{ alignmentAxis: 55, crossAxis: 15, mainAxis: -50 }"
            toggle-class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle arrow-none"
            menu-class="dropdown-menu-end"
          >
            <template #button-content>
              <img
                id="header-lang-img"
                src="@/assets/images/flags/us.svg"
                alt="Header Language"
                height="20"
                class="rounded"
              />
            </template>
            <b-link
              href="javascript:void(0);"
              class="dropdown-item notify-item language py-2"
              v-for="(entry, key) in languages"
              :data-lang="entry.language"
              :title="entry.title"
              @click="setLanguage(entry.language, entry.title, entry.flag)"
              :key="key"
            >
              <img :src="entry.flag" alt="" class="me-2 rounded" height="18" />
              <span class="align-middle">{{ entry.title }}</span>
            </b-link>
          </BDropdown>

     

       
          <div class="ms-1 header-item d-none d-sm-flex">
            <BButton
              type="button"
              variant="ghost-secondary"
              class="btn-icon btn-topbar rounded-circle light-dark-mode"
              @click="toggleDarkMode"
            >
              <i class="bx bx-moon fs-22"></i>
            </BButton>
          </div>
          <BDropdown
            variant="link"
            class="ms-sm-3 header-item topbar-user"
            toggle-class="rounded-circle arrow-none"
            menu-class="dropdown-menu-end"
            :offset="{ alignmentAxis: -14, crossAxis: 0, mainAxis: 0 }"
          >
            <template #button-content>
              <span class="d-flex align-items-center">
                <img
                  class="rounded-circle header-profile-user"
                  :src="dosya"
                  alt="Header Avatar"
                />
                <span class="text-start ms-xl-2">
                  <span
                    class="d-none d-xl-inline-block ms-1 fw-medium user-name-text"
                    >{{ this.userFullName }}</span
                  >
           
                </span>
              </span>
            </template>
            <h6 class="dropdown-header">
              {{ this.$t("Welcome") }} {{ this.userFirstName }}
            </h6>
            <b-dropdown-item
              @click="redirectToProfil()"
              link-class="d-flex align-items-center"
            >
              <font-awesome-icon icon="fa-solid fa-circle-user" />

              <span class="text-start ms-xl-2">
                {{ this.$t("Atılım Web Sitesi") }}
              </span>
            </b-dropdown-item>

          
            <div class="dropdown-divider"></div>
            <b-dropdown-item link-class="d-flex align-items-center">
              <font-awesome-icon icon="fa fa-sign-out" />
              <span class="text-start ms-xl-2" @click="logout($event)">{{
                this.$t("Logout")
              }}</span>
            </b-dropdown-item>
          </BDropdown>
        </div>
      </div>
    </div>
  </header>
</template>
<style scoped>
#page-topbar {
    left: 0 !important;
}


</style>
